<template>
  <section id="questions-section" class="section">
   <section-content-wrapper>
    <div class="question-section-title-wrapper">
    <section-title :text="'Chcesz dowiedzieć się więcej?'" xl id="question-section-heading"/>
    <section-sub-title :text="'Poniżej znajdziesz odpowiedzi na najczęściej zadawane pytania'" />
    </div>
    <div class="accordion-list-component">
      <ol class="accordion-list" aria-labelledby="question-section-heading">
        <accordion-list-item title="Jak działa brutto.pl?">
          <p>Brutto.pl to serwis internetowy, za pomocą którego możesz złożyć wniosek o finansowanie dla firm, przejść
            proces weryfikacji, uzyskać ofertę i podpisać umowę. Gdy to zrobisz – na Twoje konto trafią środki z
            finansowania.</p>
        </accordion-list-item>
        <accordion-list-item title="Kto może ubiegać się o finansowanie dla firm?">
          <p>Z oferty mogą skorzystać wszystkie podmioty, które korzystają na co dzień z Płatności Online Autopay i
            zarejestrują się w serwisie brutto.pl. Dotyczy to niemal wszystkich form prawnych, za wyjątkiem fundacji,
            stowarzyszeń i rolników (szczegóły znajdziesz w
            <a class="text-link" href="https://www.brutto.pl/regulamin/"
              title="Przejdź do strony z regulaminem">regulaminie usługi</a>). Jedynym warunkiem jest minimum
            3&#8209;miesięczna historia transakcji zrealizowanych za pośrednictwem Płatności Online Autopay oraz
            prowadzenie firmy od co najmniej 12 miesięcy.
          </p>
        </accordion-list-item>
        <accordion-list-item title="Jak sprawdzić możliwą kwotę finansowania?">
          <p>Kliknij przycisk &quot;Chcę poznać ofertę&quot;, a przekierujemy Cię na stronę brutto.pl. Tam,
            po rejestracji, uzyskasz informacje o możliwej maksymalnej kwocie finansowania dla Twojej firmy.</p>
        </accordion-list-item>
        <accordion-list-item title="Jakie dane są potrzebne do złożenia wniosku?">
          <p>Serwis brutto.pl potrzebuje jedynie informacji o wysokości sprzedaży, jaką generuje Twój serwis
            internetowy, pod który masz podpięte Płatności Online Autopay. Taka informacja zostanie automatycznie
            przekazana do brutto.pl w momencie Twojej rejestracji. Podczas akceptacji umowy w serwisie brutto.pl
            zostaniesz poproszony o podanie kwoty z ostatniej faktury VAT otrzymanej od Autopay. To wszystko.</p>
          <p>Brutto.pl nie wymaga poręczeń osobistych i żyrantów.</p>
        </accordion-list-item>
        <accordion-list-item title="Na co można przeznaczyć środki z finansowania?">
          <p>Możesz je przeznaczyć na dowolny cel związany z działalnością firmy, np. na: zakup towaru, podatki, pensje
            pracowników lub działania sprzedażowo-marketingowe.</p>
        </accordion-list-item>
        <accordion-list-item title="Po jakim czasie otrzymuje się środki?">
          <p>Środki są przekazywane za pomocą przelewu ekspresowego w dniu, w którym akceptujesz ofertę finansowania i
            podpisujesz umowę kodem SMS. W związku z tym, że cały proces odbywa się online – zajmuje zazwyczaj max.
            jeden dzień.</p>
        </accordion-list-item>
        <accordion-list-item title="Jaki jest koszt finansowania?">
          <p>Koszt zależy od wysokości uzyskanego finansowania. Dokładną kwotę poznasz po złożeniu wniosku online, gdy
            brutto.pl przygotuje ofertę dopasowaną do Twoich potrzeb i wyników sprzedażowych. Przybliżone koszty możesz
            poznać korzystając z kalkulatora lub
            <a class="text-link" href="#scenario-section" title="Przejdź do sekcji z symulacją">symulacji widocznych
              na stronie powyżej</a>.
          </p>
          <button-open-dialog :showOnlyWithHash="true" />
        </accordion-list-item>
        <accordion-list-item title="Jak odbywa się spłata?">
          <p>Raty będą pobierane automatycznie z Twojego salda w&nbsp;systemie Autopay (PayAutopay) jako - wybrany przez
            Ciebie na etapie zawierania umowy - stały procent Twojej sprzedaży wypracowany za pośrednictwem Płatności
            Online Autopay. Tak więc wysokość dziennej raty będzie zależeć od aktualnej sprzedaży. Oznacza to, że w
            przypadku spadku sprzedaży pobierane przez nas kwoty spadną (lub nawet zatrzymają się) a w przypadku wzrostu
            sprzedaży szybciej spłacisz otrzymane finansowanie. Minimalny poziom automatycznych spłat w&nbsp;czasie
            trwania pożyczki wynosi natomiast 1/9&nbsp;kwoty pożyczki co każde 45&nbsp;dni.</p>
          <p>Za operację pobierania spłat odpowiada grupa PragmaGo, w ramach której działa serwis brutto.pl - dlatego w
            trakcie składania wniosku należy wyrazić zgodę na udzielenie pełnomocnictwa właśnie tej firmie. Z
            udzielonego pełnomocnictwa można się wycofać, ale z umowy na finansowanie już nie - w takiej sytuacji spłaty
            nie będą już pobierane z salda w&nbsp;systemie Autopay (PayAutopay), lecz będzie wymagana natychmiastowa
            spłata pozostałej kwoty pożyczki.</p>
          <p>Na bazie Twojej historii sprzedaży, brutto.pl zakłada, że spłacisz należność w ciągu 12 miesięcy, ale
            dodatkowo daje Ci bezpłatny miesiąc na spłatę. Maksymalny okres spłaty wynosi zatem aż 13 miesięcy.</p>
        </accordion-list-item>
        <accordion-list-item title="Czy można zrezygnować z usługi?">
          <p>Z usługi finansowania można zrezygnować do momentu podpisania umowy, później jest to już niemożliwe.
            Możliwa jest natomiast spłata całości finansowania w dowolnym momencie trwania pożyczki. Wcześniejsza spłata
            nie wpływa natomiast na całkowite koszty finansowania.</p>
        </accordion-list-item>
      </ol>
    </div>
   </section-content-wrapper>
  </section>
</template>

<script>
import SectionTitle from '../common/SectionTitle'
import SectionSubTitle from '../common/SectionSubTitle'
import ButtonOpenDialog from '../common/ButtonOpenDialog'
import AccordionListItem from './AccordionListItem'
import SectionContentWrapper from '../common/SectionContentWrapper'

export default {
  name: 'QuestionsSection',
  components: {
    ButtonOpenDialog,
    SectionTitle,
    SectionSubTitle,
    AccordionListItem,
    SectionContentWrapper
  }
}
</script>
